/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { Field, Form } from 'formik';
import { Button, CircularProgress, FormControlLabel, Grid, Switch } from '@mui/material';
import { TextField } from 'formik-mui';

const GetchkdUserForm = ({  values, handleBlur, handleChange, setFieldValue, handleClose, isSubmitting }) => {
 

    return (


        <Form>

            <Grid container spacing={4}>
                {values.hasOwnProperty("getchkdName") && <Grid item xs={12} md={12} sm={12}>

                    <Field
                        name="getchkdName"
                        label="Getchkd Name"
                        type="text"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.getchkdName}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        component={TextField}
                    />
                </Grid>}
                {values.hasOwnProperty("detailValue")   && <Grid item xs={12} md={6} sm={6}>
                    <FormControlLabel
                        control={<Switch />}
                        name="detailValue"
                        checked={values.detailValue === "true"}
                        onChange={(event, checked) => {
                            setFieldValue("detailValue", checked ? "true" : "false");
                        }}
                        label={values.detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                    />
                </Grid>}
                <Grid item xs={12} md={12} sm={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit" style={{ marginTop: '20px' }}
                        disabled={isSubmitting}>
                        {isSubmitting &&
                            <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                    </Button>
                    <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                </Grid>

            </Grid>
        </Form>

    )

} 
export default GetchkdUserForm;